import { render, staticRenderFns } from "./CpCommentSubmitModal.vue?vue&type=template&id=75fcd4f6&scoped=true&"
import script from "./CpCommentSubmitModal.vue?vue&type=script&lang=js&"
export * from "./CpCommentSubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./CpCommentSubmitModal.vue?vue&type=style&index=0&id=75fcd4f6&scoped=true&lang=scss&"
import style1 from "./CpCommentSubmitModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fcd4f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75fcd4f6')) {
      api.createRecord('75fcd4f6', component.options)
    } else {
      api.reload('75fcd4f6', component.options)
    }
    module.hot.accept("./CpCommentSubmitModal.vue?vue&type=template&id=75fcd4f6&scoped=true&", function () {
      api.rerender('75fcd4f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/CpCommentSubmitModal.vue"
export default component.exports